import { connect } from 'react-redux';
// import MultiSignalsFooter from '../../components/MultiSignalsFooter/MultiSignalsFooter';
import MultiSignalsNavbar from '../../components/MultiSignalsNavbar/MultiSignalsNavbar';
import { useEffect } from 'react';
import './MainLayout.scss';

function MainLayout({ ...props }) {
  const { children } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div className="modern-main-layout">
      <MultiSignalsNavbar {...props} />
      <main className="main-content">
        <div className="content-container">
          <div className="content-wrapper">
            {children}
          </div>
        </div>
      </main>
      {/* <MultiSignalsFooter /> */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    MainLayoutStatus: 'True',
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);